import store from "@/store";
import { storeActions } from "@/constants/store-actions";
import { routeData } from "@/router/constants/routes";
import { navigationScenarios } from "@/router/constants/navigation-scenarios";
import { NON_POLICY_VEHICLE_ID } from "@/constants/insurance";
import {
    doesPolicyVehicleMatchEnteredVehicle,
    policyVehicleHasEndorsements,
} from "@/helpers/policy-vehicle-helper";
import { getSelectedPolicyVehicle } from "@/helpers/endorsements-helper";
import { requestPartsAndOemRevisitForSelectedVehicle } from "@/helpers/policy-vehicle-parts-swap-helper";

export async function onPolicyVehicleSelected(selectedPolicyVehicle, { shouldApply } = {}) {
    await requestPartsAndOemRevisitForSelectedVehicle({
        selectedPolicyVehicle,
        pageNameToLog: routeData.POLICY_VEHICLE.name,
        shouldApply,
    });
}

export async function policyVehicleBeforeEnter(to) {
    if (store.getters.order?.vehicle?.policyVehicleId != null) {
        if (policyVehicleHasEndorsements(getSelectedPolicyVehicle(store.getters.order))) {
            return {
                name: routeData.ENDORSEMENTS.name,
            };
        }
        return {
            name: routeData.POLICY_INFO_SUBMITTED.name,
        };
    }

    const policyInformation = await store.dispatch(storeActions.GET_POLICY_INFORMATION, {
        pageNameToLog: to.name,
    });

    const vehicles = policyInformation?.policies?.[0]?.vehicles ?? [];
    if (!vehicles.length) {
        const correctionSubmitted =
            store.getters.pageData(routeData.VERIFY_DETAILS.name)?.correctionSubmitted === true;

        return {
            name: correctionSubmitted
                ? routeData.POLICY_INFO_SUBMITTED.name
                : routeData.VERIFY_DETAILS.name,
        };
    }
}

export async function getForwardNavigationScenario({
    selectedPolicyVehicle = null,
    isNonPolicyVehicle = false,
} = {}) {
    if (isNonPolicyVehicle) {
        await store.dispatch(storeActions.SAVE_POLICY_VEHICLE_ID, NON_POLICY_VEHICLE_ID);
        return navigationScenarios.CLICKED_FORWARD_WITHOUT_POLICY_VEHICLE;
    }

    const enteredVehicle = store.getters.order?.vehicle;
    const isMatch = doesPolicyVehicleMatchEnteredVehicle(selectedPolicyVehicle, enteredVehicle);

    if (!isMatch) {
        await store.dispatch(storeActions.SAVE_UNMATCHED_POLICY_VEHICLE, selectedPolicyVehicle);
        if (store.getters.order?.vehicle?.carId) {
            return navigationScenarios.CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE;
        }
        return navigationScenarios.CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE_WITHOUT_CAR_ID;
    }

    await store.dispatch(storeActions.SAVE_MATCHED_POLICY_VEHICLE, selectedPolicyVehicle);

    if (policyVehicleHasEndorsements(selectedPolicyVehicle)) {
        return navigationScenarios.CLICKED_FORWARD_WITH_ENDORSEMENTS;
    }

    return navigationScenarios.CLICKED_FORWARD_WITHOUT_ENDORSEMENTS;
}
